var map = {
	"./": 87,
	"./App": 116,
	"./App.js": 116,
	"./assets/fonts/HelveticaNeue-Thin.woff": 461,
	"./assets/fonts/HelveticaNeue-Thin.woff2": 462,
	"./assets/fonts/HelveticaNeueLT-Medium.woff": 463,
	"./assets/fonts/HelveticaNeueLT-Medium.woff2": 464,
	"./assets/fonts/HelveticaNeueLTStd-Bd.woff": 465,
	"./assets/fonts/HelveticaNeueLTStd-Bd.woff2": 466,
	"./assets/fonts/HelveticaNeueLTStd-Lt.woff": 467,
	"./assets/fonts/HelveticaNeueLTStd-Lt.woff2": 468,
	"./assets/fonts/HelveticaNeueLTStd-Md.woff": 469,
	"./assets/fonts/HelveticaNeueLTStd-Md.woff2": 470,
	"./assets/fonts/Roboto-Regular.woff": 471,
	"./assets/fonts/Roboto-Regular.woff2": 472,
	"./assets/fonts/founders-grotesk-web-bold.woff2": 473,
	"./assets/fonts/founders-grotesk-web-light.woff2": 474,
	"./assets/fonts/founders-grotesk-web-medium.woff2": 475,
	"./assets/fonts/founders-grotesk-web-regular.woff2": 476,
	"./assets/fonts/founders-grotesk-web-semibold.woff2": 477,
	"./assets/images/amenities/Amenities-Hero.jpg": 155,
	"./assets/images/amenities/amenities-1.jpg": 230,
	"./assets/images/amenities/amenities-2.jpg": 231,
	"./assets/images/amenities/amenities-3.jpg": 232,
	"./assets/images/amenities/amenities-4.jpg": 233,
	"./assets/images/amenities/amenities-main-en.png": 234,
	"./assets/images/amenities/amenities-main-sc.png": 235,
	"./assets/images/amenities/amenities-main-tc.png": 236,
	"./assets/images/background.jpeg": 478,
	"./assets/images/background.png": 78,
	"./assets/images/contact/contact_hero.jpg": 237,
	"./assets/images/contact/gn_map_pin.png": 238,
	"./assets/images/footer/logos/gryphon-logo.svg": 226,
	"./assets/images/footer/logos/gryphon-nova-logo.svg": 120,
	"./assets/images/footer/social/facebook-icon.svg": 227,
	"./assets/images/footer/social/instagram-icon.svg": 228,
	"./assets/images/footer/social/wechat-icon.svg": 479,
	"./assets/images/footer/social/youtube-icon.svg": 229,
	"./assets/images/gryphon-nest/Nest-Hero.jpg": 156,
	"./assets/images/gryphon-nest/bookmarks/en/air-en.svg": 192,
	"./assets/images/gryphon-nest/bookmarks/en/app-en.svg": 194,
	"./assets/images/gryphon-nest/bookmarks/en/ev-en.svg": 198,
	"./assets/images/gryphon-nest/bookmarks/en/furniture-en.svg": 480,
	"./assets/images/gryphon-nest/bookmarks/en/locker-en.svg": 196,
	"./assets/images/gryphon-nest/bookmarks/en/plate-en.svg": 197,
	"./assets/images/gryphon-nest/bookmarks/en/uv-en.svg": 193,
	"./assets/images/gryphon-nest/bookmarks/en/water-en.svg": 191,
	"./assets/images/gryphon-nest/bookmarks/en/window-en.svg": 195,
	"./assets/images/gryphon-nest/bookmarks/sc/air-sc.svg": 481,
	"./assets/images/gryphon-nest/bookmarks/sc/app-sc.svg": 482,
	"./assets/images/gryphon-nest/bookmarks/sc/ev-sc.svg": 483,
	"./assets/images/gryphon-nest/bookmarks/sc/furniture-sc.svg": 484,
	"./assets/images/gryphon-nest/bookmarks/sc/locker-sc.svg": 485,
	"./assets/images/gryphon-nest/bookmarks/sc/plate-sc.svg": 486,
	"./assets/images/gryphon-nest/bookmarks/sc/uv-sc.svg": 487,
	"./assets/images/gryphon-nest/bookmarks/sc/water-sc.svg": 488,
	"./assets/images/gryphon-nest/bookmarks/sc/window-sc.svg": 489,
	"./assets/images/gryphon-nest/bookmarks/tc/air-tc.svg": 200,
	"./assets/images/gryphon-nest/bookmarks/tc/app-tc.svg": 202,
	"./assets/images/gryphon-nest/bookmarks/tc/ev-tc.svg": 206,
	"./assets/images/gryphon-nest/bookmarks/tc/furniture-tc.svg": 490,
	"./assets/images/gryphon-nest/bookmarks/tc/locker-tc.svg": 204,
	"./assets/images/gryphon-nest/bookmarks/tc/plate-tc.svg": 205,
	"./assets/images/gryphon-nest/bookmarks/tc/uv-tc.svg": 201,
	"./assets/images/gryphon-nest/bookmarks/tc/water-tc.svg": 199,
	"./assets/images/gryphon-nest/bookmarks/tc/window-tc.svg": 203,
	"./assets/images/gryphon-nest/logos/gryphon-nest-logo.svg": 157,
	"./assets/images/header/icon-close.svg": 224,
	"./assets/images/header/icon-menu.svg": 225,
	"./assets/images/header/navigation-background.png": 491,
	"./assets/images/home/hero-landing.jpg": 239,
	"./assets/images/home/hero-royal.jpg": 240,
	"./assets/images/home/the-art-of-innovation.svg": 154,
	"./assets/images/location/Location-Hero.jpg": 158,
	"./assets/images/location/location-1.jpg": 241,
	"./assets/images/location/location-2.jpg": 242,
	"./assets/images/location/location-3.jpg": 243,
	"./assets/images/location/location-4.jpg": 244,
	"./assets/images/location/location-5.jpg": 245,
	"./assets/images/logo.svg": 182,
	"./assets/images/menu-background.png": 138,
	"./assets/images/register/register-hero.jpg": 246,
	"./assets/images/residences/Residences-Hero.jpg": 159,
	"./assets/images/residences/ensuite-dark.jpg": 247,
	"./assets/images/residences/ensuite-light.jpg": 248,
	"./assets/images/residences/featured-1-bed-en.png": 249,
	"./assets/images/residences/featured-1-bed-sc.png": 250,
	"./assets/images/residences/featured-1-bed-tc.png": 251,
	"./assets/images/residences/featured-1-bed.png": 492,
	"./assets/images/residences/featured-2-bed-en.png": 252,
	"./assets/images/residences/featured-2-bed-sc.png": 253,
	"./assets/images/residences/featured-2-bed-tc.png": 254,
	"./assets/images/residences/featured-2-bed.png": 493,
	"./assets/images/residences/featured-3-bed-en.png": 255,
	"./assets/images/residences/featured-3-bed-sc.png": 256,
	"./assets/images/residences/featured-3-bed-tc.png": 257,
	"./assets/images/residences/featured-3-bed.png": 494,
	"./assets/images/residences/kitchen-dark.jpg": 258,
	"./assets/images/residences/kitchen-light.jpg": 259,
	"./assets/images/residences/upgrade-ensuite.jpg": 260,
	"./assets/images/residences/upgrade-kitchen.jpg": 261,
	"./components/Background": 66,
	"./components/Background.js": 66,
	"./components/Button": 36,
	"./components/Button.js": 36,
	"./components/Counter": 123,
	"./components/Counter.js": 123,
	"./components/Footer/Footer": 52,
	"./components/Footer/Footer.js": 52,
	"./components/Form/Form": 124,
	"./components/Form/Form.js": 124,
	"./components/Form/elements/Checkbox": 125,
	"./components/Form/elements/Checkbox.js": 125,
	"./components/Form/elements/Input": 54,
	"./components/Form/elements/Input.js": 54,
	"./components/Form/elements/LoadingDots": 126,
	"./components/Form/elements/LoadingDots.js": 126,
	"./components/Form/elements/Select": 79,
	"./components/Form/elements/Select.js": 79,
	"./components/Header/Header": 118,
	"./components/Header/Header.js": 118,
	"./components/Header/elements/LanguageSelector": 65,
	"./components/Header/elements/LanguageSelector.js": 65,
	"./components/Header/elements/Navigation": 262,
	"./components/Header/elements/Navigation.js": 262,
	"./components/Header/elements/Overlay": 119,
	"./components/Header/elements/Overlay.js": 119,
	"./components/Header/elements/TopBar": 64,
	"./components/Header/elements/TopBar.js": 64,
	"./components/Intl": 10,
	"./components/Intl.js": 10,
	"./components/Loading": 122,
	"./components/Loading.js": 122,
	"./components/Logo": 263,
	"./components/Logo.js": 263,
	"./components/Page": 19,
	"./components/Page.js": 19,
	"./components/Video/Video": 67,
	"./components/Video/Video.js": 67,
	"./components/Video/elements/Bookmark": 129,
	"./components/Video/elements/Bookmark.js": 129,
	"./components/Video/elements/ControlBar": 128,
	"./components/Video/elements/ControlBar.js": 128,
	"./components/Video/elements/Player": 127,
	"./components/Video/elements/Player.js": 127,
	"./components/Video/elements/ProgressBar": 130,
	"./components/Video/elements/ProgressBar.js": 130,
	"./components/layout/Content": 41,
	"./components/layout/Content.js": 41,
	"./components/layout/GoogleMapBlock": 81,
	"./components/layout/GoogleMapBlock.js": 81,
	"./components/layout/Hero": 26,
	"./components/layout/Hero.js": 26,
	"./components/layout/ImageContent": 80,
	"./components/layout/ImageContent.js": 80,
	"./components/layout/LargeContent": 132,
	"./components/layout/LargeContent.js": 132,
	"./components/layout/Separator": 82,
	"./components/layout/Separator.js": 82,
	"./components/typography/LineLink": 133,
	"./components/typography/LineLink.js": 133,
	"./config/app.conf": 8,
	"./config/app.conf.js": 8,
	"./config/locales/en": 89,
	"./config/locales/en.js": 89,
	"./config/locales/tc": 90,
	"./config/locales/tc.js": 90,
	"./data/content": 30,
	"./data/content.js": 30,
	"./data/hero": 53,
	"./data/hero.js": 53,
	"./data/locationImages": 134,
	"./data/locationImages.js": 134,
	"./data/map": 131,
	"./data/map.js": 131,
	"./data/otherImages": 51,
	"./data/otherImages.js": 51,
	"./data/residencesImages": 83,
	"./data/residencesImages.js": 83,
	"./data/social": 121,
	"./data/social.js": 121,
	"./index": 87,
	"./index.js": 87,
	"./pages/About": 267,
	"./pages/About.js": 267,
	"./pages/Amenities/Amenities": 268,
	"./pages/Amenities/Amenities.js": 268,
	"./pages/Contact/Contact": 269,
	"./pages/Contact/Contact.js": 269,
	"./pages/Home": 270,
	"./pages/Home.js": 270,
	"./pages/Location/Location": 271,
	"./pages/Location/Location.js": 271,
	"./pages/Nest/Nest": 272,
	"./pages/Nest/Nest.js": 272,
	"./pages/NotFound": 273,
	"./pages/NotFound.js": 273,
	"./pages/Register/Register": 274,
	"./pages/Register/Register.js": 274,
	"./pages/Residences/Residences": 275,
	"./pages/Residences/Residences.js": 275,
	"./pages/ThankYou/ThankYou": 276,
	"./pages/ThankYou/ThankYou.js": 276,
	"./plugins/Analytics/Analytics": 111,
	"./plugins/Analytics/Analytics.js": 111,
	"./plugins/Analytics/elements/GTM": 113,
	"./plugins/Analytics/elements/GTM.js": 113,
	"./plugins/Analytics/elements/GTag": 112,
	"./plugins/Analytics/elements/GTag.js": 112,
	"./plugins/Analytics/elements/Hotjar": 114,
	"./plugins/Analytics/elements/Hotjar.js": 114,
	"./plugins/OnUpdate": 35,
	"./plugins/OnUpdate.js": 35,
	"./plugins/RedirectByIP": 115,
	"./plugins/RedirectByIP.js": 115,
	"./plugins/SEO": 110,
	"./plugins/SEO.js": 110,
	"./plugins/insight": 277,
	"./plugins/insight.js": 277,
	"./plugins/language": 108,
	"./plugins/language.js": 108,
	"./plugins/prerender": 117,
	"./plugins/prerender.js": 117,
	"./plugins/scrollTop": 109,
	"./plugins/scrollTop.js": 109,
	"./plugins/sitemap-generator": 331,
	"./plugins/sitemap-generator.js": 331,
	"./redux/counter": 44,
	"./redux/counter.js": 44,
	"./redux/intl": 61,
	"./redux/intl.js": 61,
	"./redux/loader": 62,
	"./redux/loader.js": 62,
	"./redux/reducers": 107,
	"./redux/reducers.js": 107,
	"./redux/store": 106,
	"./redux/store.js": 106,
	"./redux/tracking": 40,
	"./redux/tracking.js": 40,
	"./routes": 63,
	"./routes.js": 63,
	"./styles/fonts.css": 189,
	"./styles/global": 105,
	"./styles/global.js": 105,
	"./styles/media": 4,
	"./styles/media.js": 4,
	"./styles/theme": 37,
	"./styles/theme.js": 37,
	"./styles/utils": 1,
	"./styles/utils.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;